import axios from 'axios';
import { environment } from '../../../api/environment';

const TELMEX_URLS = {
    production: 'https://eco-digital-tlmx.dish.com.mx/consulta_telmex',
    qa: 'https://eco-digital-ventas-stage.gdevdish.name/consulta_telmex',
    dev: 'https://eco-digital-ventas-stage.gdevdish.name/consulta_telmex',
    dishmxdev: 'https://eco-digital-ventas-stage.gdevdish.name/consulta_telmex'
};

const telmexBaseURL = TELMEX_URLS[environment.ENV] || TELMEX_URLS.qa;

/**
 * Valida el número telefónico de Telmex
 */
export const validateTelmex = async ({ commit, rootState }, params) => {
    try {
        commit('SET_LOADING', true);

        const token = rootState.Token.token.dataObj;
        const telmex = params.telmex.replace(/-/g, '').replace(/ /g, '');
        
        const { data } = await axios.request({
            method: 'post',
            baseURL: telmexBaseURL,
            data: {
                numeroTelefono: telmex,
                generarFolio: false
            }
        });

        if (data) {
            const codigoRespuesta = data.codigoRespuesta;
            if (codigoRespuesta == '000') {
                commit('SET_TELMEX_NUMBER', data.numTelefonico);
            } else {
                commit('SET_ERROR_SUBSCRIPTION', data.mensajeRespuesta);
            }
        }
    } catch (err) {
        console.log(err);
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};
